// extracted by mini-css-extract-plugin
export default {"body":"Livechat_body__ixKsc","inputDiv":"Livechat_inputDiv__k4y+d","input":"Livechat_input__lSIWF","btn":"Livechat_btn__xJKbB","btnGroup":"Livechat_btnGroup__d4ijf"};